// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"e_bi","imageUI":"e_ci","badgeContainer":"e_di","badgeImage":"e_ei","container":"e_fi"};